import * as React from "react";
import { forwardRef } from "react";
const SvgCrossIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 33, height: 32, viewBox: "0 0 33 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M22.0999 10.3999L10.8999 21.5999M22.0999 21.5999L10.8999 10.3999L22.0999 21.5999Z", stroke: "#F2F2F4", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgCrossIcon);
export { ForwardRef as ReactComponent };
